/* Column template must match .row in ConnectionRow.module.css */
.columnHeader {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 120px 110px;
    gap: 16px;
    padding: 10px 16px;
    border-bottom: 1px solid var(--exo-color-border-secondary);
    font-size: 12px;
    font-weight: 600;
    color: var(--exo-color-font-secondary);
    text-transform: uppercase;
    letter-spacing: 0.04em;
}
